import { useState } from "react";
import { useAppContext } from "../../src/context/AppContext";
import { contact } from "../services/contactService";
import { LandingTrans } from "../utils/translations";

const ContactForm = () => {
  const { language, setToaster, user } = useAppContext();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await contact(formData);
      setFormData({ name: "", phone: "", message: "" });
      setToaster({
        message: "Сообщение отправлено!",
        type: "success",
        show: true,
      });
    } catch (error) {
      console.error(error);
      setToaster({
        message: "Ошибка сервера!",
        type: "error",
        show: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3 className="md:m-0 m-auto w-fit text-xl font-semibold pb-2 md:mt-0 mt-5">{LandingTrans[language].leaveRequest}</h3>
      <form
        onSubmit={handleSubmit}
        className="bg-beige rounded-xl p-3 pt-5 shadow-md space-y-4"
      >
        <input
          type="text"
          name="name"
          placeholder={LandingTrans[language].yourName}
          value={formData.name}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400"
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder={LandingTrans[language].yourPhone}
          value={formData.phone}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400"
        />
        <textarea
          name="message"
          placeholder={LandingTrans[language].commentOrQuestion}
          value={formData.message}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-2 h-16 resize-none focus:outline-none focus:ring-2 focus:ring-pink-400"
          required
        ></textarea>

        <button
          type="submit"
          disabled={loading}
          className={`mx-auto flex items-center justify-center gap-2 px-6 py-2 rounded-lg text-white transition ${
            loading
              ? "bg-pink cursor-not-allowed"
              : "bg-brown hover:bg-pink"
          }`}
        >
          {loading && (
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
              ></path>
            </svg>
          )}
          {loading ? LandingTrans[language].sending : LandingTrans[language].send}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
